import React from "react"

// Hooks
import { useTailPadBot, useTailPadTop } from "../../hooks"

export const StandardBlockWrapper = ({
  backgroundColor,
  padding,
  children,
  className,
}) => {
  const paddingTop = useTailPadTop((padding && padding.top) || "0")
  const paddingBottom = useTailPadBot((padding && padding.bottom) || "0")

  return (
    <section
      style={{ backgroundColor: backgroundColor && backgroundColor.hex }}
      className={`${paddingTop} ${paddingBottom} ${className}`}
    >
      {children}
    </section>
  )
}
